import { Socket } from "rete";

const trigger = new Socket("Trigger");
const triggered = new Socket("Triggered");

trigger.combineWith(triggered);
triggered.combineWith(trigger);

export { trigger, triggered };
